import React from "react";
import logo from "../image/main-logo.svg";

export default function () {
  return (
    <div className="simple-top-bar absolute top-0 left-0 z-[505] w-screen h-20">
      <div className="simple-bar-content h-full items-center flex flex-row ml-[30px] [&_h3]:m-0 [&_h3]:ml-8 [&_h3]:font-[Manrope,serif] [&_h3]:text-xl [&_h3]:font-light [&_h3]:leading-[27px] [&_h3]:text-center">
        <img alt="eDigi logo" height="100%" src={logo} width="128px" />
      </div>
    </div>
  );
}
